class ErrorStatus {
    static PAYMENT_PROVIDER_INTERNAL_SERVER_ERROR = 'C0';
    static PAYMENT_PROVIDER_401 = 'C1';
    static COMMON_INTERNAL_ERROR = 'C2';
    static PROVIDER_ERROR_CODE = 'C3';
}

export default ErrorStatus;
